import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/disassemble/list',
  title: '拆解管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
